import type {
  CreateListingActionRequest,
  ListingActionDto,
  ListingActionsResponse,
} from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export const listingActionsApi = {
  async list(businessId: string, listingId: string): Promise<ListingActionsResponse> {
    const res = await api.api.businesses[':businessId'].listings[':id'].actions.$get({
      param: { businessId, id: listingId },
    })
    return unwrap<ListingActionsResponse>(res)
  },

  async create(
    businessId: string,
    listingId: string,
    input: CreateListingActionRequest,
  ): Promise<ListingActionDto> {
    const res = await api.api.businesses[':businessId'].listings[':id'].actions.$post({
      param: { businessId, id: listingId },
      json: input,
    })
    return unwrap<ListingActionDto>(res)
  },

  async end(businessId: string, listingId: string, actionId: string): Promise<ListingActionDto> {
    const res = await api.api.businesses[':businessId'].listings[':id'].actions[
      ':actionId'
    ].end.$post({ param: { businessId, id: listingId, actionId } })
    return unwrap<ListingActionDto>(res)
  },
}
